import * as React from 'react';
import { useCallback } from 'react';
import cn from 'classnames';
import SubsidiesSelector from '../../../../Subsidies/components/SubsidiesSelector/SubsidiesSelector';
import styles from './PassengerSubsidySelect.css';
const PassengerSubsidySelect = props => {
    const { options, value, onChange, onBlur, disabled, error, className, multiple = false } = props;
    const handleOptionClick = useCallback((optionKey) => (event) => {
        // Приводим к HTMLInputElement для доступа к checked
        const inputEvent = event;
        const isChecked = inputEvent.target.checked;
        if (multiple) {
            // Multi-select режим
            const currentValue = Array.isArray(value) ? value : value ? [value] : [];
            const newValue = isChecked ? [...currentValue, optionKey] : currentValue.filter(id => id !== optionKey);
            // Создаем синтетическое событие с правильным target.value
            const syntheticEvent = Object.assign(Object.assign({}, event), { target: Object.assign(Object.assign({}, event.target), { value: newValue }) });
            onChange(newValue, syntheticEvent);
        }
        else {
            // Single-select режим
            const newValue = isChecked ? optionKey : '';
            // Создаем синтетическое событие с правильным target.value
            const syntheticEvent = Object.assign(Object.assign({}, event), { target: Object.assign(Object.assign({}, event.target), { value: newValue }) });
            onChange(newValue, syntheticEvent);
        }
    }, [value, onChange, multiple]);
    const isSelected = useCallback((optionKey) => {
        if (multiple) {
            const currentValue = Array.isArray(value) ? value : value ? [value] : [];
            return currentValue.includes(optionKey);
        }
        else {
            const currentValue = Array.isArray(value) ? value[0] : value;
            return currentValue === optionKey;
        }
    }, [value, multiple]);
    return (React.createElement("div", { className: cn(styles.container, className), onBlur: onBlur },
        React.createElement("div", { className: styles.optionsList }, options.map(option => (React.createElement(SubsidiesSelector, { key: option.key, id: option.key, type: option.type, isSelected: isSelected(option.key), onChange: handleOptionClick(option.key), disabled: disabled || option.disabled, className: styles.option })))),
        error && React.createElement("div", { className: styles.error }, error)));
};
export default PassengerSubsidySelect;
